import RTMClient from './rtm-client';

export default class RtmInstance extends RTMClient {
  static instance = RtmInstance.instance || new RTMClient();
}
